<template lang="pug">
  multiselect(
    track-by="label"
    label="label"
    :disabled="disabled"
    :options="options"
    :searchable="live"
    :multiple="multiple"
    :close-on-select="!multiple"
    :show-labels="false"
    :placeholder="placeholder"
    :taggable="true"
    v-model="currentValue")
    span(slot="noResult") 没有选项
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'SmartFormSelect',
  components: {
    Multiselect
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    live: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    value: {
      type: String | Number
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    currentValue: {
      get () {
        if (this.multiple) {
          return this.options.filter(item => this.value.indexOf(item.value) >= 0)
        } else {
          return this.options.find(item => item.value === this.value)
        }
      },
      set (val) {
        if (this.multiple) {
          this.$emit('input', val.map(v => v.value))
        } else {
          this.$emit('input', val ? val.value : val)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// SmartSelect.vue?d7caccb2